module.exports = __webpack_public_path__ + "img/check-green.e03a40b4.svg";